import { render, staticRenderFns } from "./recibirgarantia.vue?vue&type=template&id=d6b365ba&"
import script from "./recibirgarantia.vue?vue&type=script&lang=js&"
export * from "./recibirgarantia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports